import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./en/translations.json')
    },
    tm: {
      translations: require('./tm/translations.json')
    },
    arab: {
      translations: require('./arab/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'tm', 'arab'];

export default i18n;
